export default "__VITE_ASSET__C$kyzs_x__"